module.exports = "https://www.ilove11.top/img/face22.2de3b3a6.gif";